module.exports = __webpack_public_path__ + "img/9788959522781.50a6bb72.jpg";